/* FOM · utilitarios de DOM.

   Existem para que as telas novas nao repitam createElement quinze vezes por
   funcao. Nao sao um framework: nao ha estado aqui, nao ha ciclo de vida, e
   nada nesta camada conhece o dominio. */

export function el<K extends keyof HTMLElementTagNameMap>(
  tag: K,
  classe?: string,
  conteudo?: string,
): HTMLElementTagNameMap[K] {
  const e = document.createElement(tag);
  if (classe) e.className = classe;
  if (conteudo !== undefined) e.textContent = conteudo;
  return e;
}

export function botao(
  rotulo: string,
  aoClicar: () => void,
  classe = 'botao',
): HTMLButtonElement {
  const b = el('button', classe, rotulo);
  b.type = 'button';
  b.addEventListener('click', aoClicar);
  return b;
}

/* Um campo rotulado. O rotulo e um <label> de verdade, ligado ao controle:
   quem navega por teclado ou leitor de tela depende disso. */
export function campo(
  rotulo: string,
  controle: HTMLElement,
  dica?: string,
): HTMLElement {
  const linha = el('label', 'campo');
  linha.appendChild(el('span', 'campo-rotulo', rotulo));
  linha.appendChild(controle);
  if (dica) linha.appendChild(el('span', 'campo-dica', dica));
  return linha;
}

export function entrada(valor = '', placeholder = ''): HTMLInputElement {
  const i = el('input', 'entrada');
  i.type = 'text';
  i.value = valor;
  i.placeholder = placeholder;
  return i;
}

export function area(valor = '', linhas = 3, placeholder = ''): HTMLTextAreaElement {
  const a = el('textarea', 'entrada');
  a.rows = linhas;
  a.value = valor;
  a.placeholder = placeholder;
  return a;
}

export function selecao(
  opcoes: { valor: string; rotulo: string; desabilitado?: boolean }[],
  valor?: string,
): HTMLSelectElement {
  const s = el('select', 'entrada');
  for (const o of opcoes) {
    const op = el('option', undefined, o.rotulo);
    op.value = o.valor;
    if (o.desabilitado) op.disabled = true;
    s.appendChild(op);
  }
  if (valor !== undefined) s.value = valor;
  return s;
}

export function limpar(host: HTMLElement): void {
  host.innerHTML = '';
}

/* Estado vazio com voz: diz o que falta e por que, em vez de deixar um branco
   que o usuario tem de interpretar. */
export function vazio(mensagem: string, detalhe?: string): HTMLElement {
  const d = el('div', 'estado-vazio');
  d.appendChild(el('p', 'estado-vazio-titulo', mensagem));
  if (detalhe) d.appendChild(el('p', 'estado-vazio-detalhe', detalhe));
  return d;
}

export function dataCurta(iso: string | null): string {
  if (!iso) return '—';
  return iso.slice(0, 16).replace('T', ' ');
}
